module.exports = __webpack_public_path__ + "img/baidu.60df3ee2.jpg";